var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompliantMiddleware(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.523,
    height: 28.523,
    viewBox: "0 0 28.523 28.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18335"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12896",
    d: "M900.935 151.871a6.936 6.936 0 1 0-6.935-6.936 6.937 6.937 0 0 0 6.935 6.936z",
    transform: "translate(-886.674 -130.675)",
    style: {
      fill: "#f27090"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12897",
    d: "M899.739 153.739a10 10 0 1 0-10-10 10 10 0 0 0 10 10z",
    transform: "translate(-885.478 -129.478)",
    style: {
      fill: "none",
      stroke: "rgba(179,198,223,.1)",
      strokeWidth: "8.523px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliantMiddleware);
export default __webpack_public_path__ + "static/media/compliant-middleware.83e387280b419cdd63ea94cf0fc50980.svg";
export { ForwardRef as ReactComponent };